module.exports = __webpack_public_path__ + "static/dgs-bw-6c295234fdc93c196930438d6a239001.jpg";